module.exports = __webpack_public_path__ + "static/img/t8.71049e35.png";